import React, { useState, useEffect } from 'react';
import classNames from "classnames";
import PropTypes from 'prop-types';

import { Container, Title, WrapperTitle, WrapperAddButton, WrapperTitleContent } from './components';
import ConfigService from "../../../Services/api/Config";
import IconBlue from "../../Common/Icon/blue";
import Icon from "../../Common/Icon";
import {ReactComponent as ArrowIcon} from "../../../../img/down-arrow-dark.svg";
import {ReactComponent as AddIcon} from "../../../../img/dialog-close-white.svg";

const CollapseableSection = ({
  theme,
  sectionTitle,
  section,
  required,
  initCollapsed,
  onAddChat,
  // Outside control
  onPressRemoteCollapse,
  sectionId,
  control,
  numMessages,
}) => {

  const [ collapsed, setCollapse ] = useState(initCollapsed ? initCollapsed : false);
  
  useEffect(() => {
    setCollapse(initCollapsed);
  }, [initCollapsed]);

  const onPressCollapse = () => {
    if (onPressRemoteCollapse) {
      onPressRemoteCollapse(sectionId);
      return;
    }
    setCollapse(!collapsed);
  };
  
  return (
    <Container borderColor={ ConfigService.getColor('tertiaryColor', 0.3) }>
      <WrapperTitle>
        <WrapperTitleContent onClick={onPressCollapse}>
          <Icon
            className={ classNames('Icon-Arrow', {
              'Icon-Arrow-Closed': Boolean(!collapsed),
            })}
            width='15'
            height='7'
            color='primaryColor'
          >
            <ArrowIcon alt='icon-arrow'/>
          </Icon>
          <Title
            textColor={ ConfigService.getColor('primaryColor') }
          >
            {sectionTitle}
            {required && (
              <span>
                {` *`}
              </span>
            )}
          </Title>
          { collapsed && numMessages > 0 &&
            <IconBlue>{numMessages}</IconBlue>
          }
        </WrapperTitleContent>

        { sectionTitle === 'Direct Messages' &&
          <WrapperAddButton
            backgroundColor={ ConfigService.getColor('tertiaryColor')}
            onClick={onAddChat}
          >
            <Icon
              width='12'
              height='12'
            >
              <AddIcon alt='icon-add'/>
            </Icon>
          </WrapperAddButton>
        }
      </WrapperTitle>
      {!collapsed && !control && (
        section
      )}
    </Container>
  )
};

CollapseableSection.propTypes = {
  sectionTitle: PropTypes.string.isRequired,
  section: PropTypes.element.isRequired,
  theme: PropTypes.object,
  required: PropTypes.bool,
  initCollapsed: PropTypes.bool,
  onAddChat: PropTypes.func,
  onPressRemoteCollapse: PropTypes.func,
  control: PropTypes.bool,
  numMessages: PropTypes.number,
};

export default CollapseableSection;